export default __webpack_public_path__ + "static/media/tab4-image2.b4e69d59.png";